/* Inéa V4 — en-tête : menu mobile et pastille du panier. */
(function () {
  if (window.__iv4Header) return;
  window.__iv4Header = true;

  function init() {
    // Ancre absente de la page courante (ex. « Packs » depuis le panier) : on renvoie vers la section équivalente de l'accueil.
    document.querySelectorAll('[data-iv4-header] a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id || document.getElementById(id)) return;
        e.preventDefault();
        window.location.href = '/#' + (id === 'bundle' ? 'packs' : id);
      });
    });

    var burger = document.querySelector('[data-iv4-burger]');
    var menu = document.getElementById('Iv4MobileMenu');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      });
      menu.addEventListener('click', function (e) {
        if (e.target.tagName === 'A') { menu.hidden = true; burger.setAttribute('aria-expanded', 'false'); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) { menu.hidden = true; burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
      });
    }
  }

  // Le configurateur produit déclenche cet événement après /cart/add.js.
  document.addEventListener('iv4:cart-updated', function (e) {
    var count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-iv4-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });

  // En-tête fixe : effet verre dépoli dès que la page défile.
  function watchScroll() {
    var h = document.querySelector('[data-iv4-header]'); if (!h) return;
    var on = null;
    function update() { var s = window.scrollY > 8; if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); } }
    window.addEventListener('scroll', update, { passive: true }); update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); watchScroll(); }); else { init(); watchScroll(); }
})();
